'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    upload: '上传',
    submit: '提交',
    cancel: '取消',
    preview: '预览',
    'edit picture': '编辑图片',
    'drag to crop': '拖动以调整大小',
    'click to upload': '点击上传'
};
module.exports = exports['default'];